import MsecDuratives from '../modules/MsecDuratives.js';

class LoopDefinition extends MsecDuratives {
  static name = 'LoopDefinition';
}

export default LoopDefinition;
